import React, { Fragment } from 'react'

export default () => <Fragment>{''}</Fragment>



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Feature/FeatureContainer/DefaultFeature.js